import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Trash2, Heart, MessageCircle } from "lucide-react";

export default function AdminCommunity() {
  const [posts, setPosts] = useState([]);

  const load = () => api.get("/community/posts").then((r) => setPosts(r.data));
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Delete this post?")) return;
    await api.delete(`/admin/community/posts/${id}`);
    toast.success("Post deleted.");
    load();
  };

  return (
    <div className="text-white">
      <div className="uppercase tracking-[0.28em] text-xs text-brand-pink mb-3">Community</div>
      <h1 className="font-display text-4xl mb-8">Moderate the feed.</h1>

      <div className="space-y-3">
        {posts.map((p) => (
          <div key={p.id} data-testid={`admin-post-${p.id}`} className="rounded-2xl bg-white/5 border border-white/10 p-5 flex gap-4 items-start">
            <div className="w-10 h-10 rounded-full bg-brand-pink/20 flex items-center justify-center text-brand-pink font-medium">{p.author_name?.[0] || "?"}</div>
            <div className="flex-1">
              <div className="text-sm text-white/70"><span className="text-white">{p.author_name}</span> · {p.category} · {new Date(p.created_at).toLocaleDateString()}</div>
              <div className="text-white/90 mt-1">{p.content}</div>
              <div className="flex gap-4 text-xs text-white/50 mt-3">
                <span className="inline-flex items-center gap-1"><Heart className="w-3 h-3" /> {p.likes || 0}</span>
                <span className="inline-flex items-center gap-1"><MessageCircle className="w-3 h-3" /> {p.comments?.length || 0}</span>
              </div>
            </div>
            <Button variant="ghost" onClick={() => del(p.id)} data-testid={`admin-post-del-${p.id}`} className="text-brand-pink hover:bg-brand-pink/10 rounded-full">
              <Trash2 className="w-4 h-4" />
            </Button>
          </div>
        ))}
        {posts.length === 0 && <div className="text-white/50 text-center py-10">No posts yet.</div>}
      </div>
    </div>
  );
}
